import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import BrandsSection from "@/components/BrandsSection";
import ClientsSection from "@/components/ClientsSection";
import JoinTeamSection from "@/components/JoinTeamSection";
import ContactSection from "@/components/ContactSection";
import CookieConsent from "@/components/CookieConsent";

const Index = () => {
  return (
    <div className="bg-background min-h-screen">
      <SEOHead canonical="https://evk.pt/" />
      <Navbar />
      <HeroSection />
      <BrandsSection />
      <ClientsSection />
      <JoinTeamSection />
      <ContactSection />
      <CookieConsent />
    </div>
  );
};

export default Index;
